<template>
  <v-col>
    <v-card>
      <v-card-title>
        <app-title headline> Add Manual Points </app-title>
      </v-card-title>
      <v-card-text>
        <div>
          <v-btn @click="addPoints" class="primary mr-1">Add Points</v-btn>
          <v-btn
            @click="editPoints"
            class="primary mx-1"
            :disabled="selected.length != 1"
            >Edit</v-btn
          >
          <v-btn
            @click="deletePoints"
            class="error ml-1"
            :disabled="selected.length == 0"
            >Delete</v-btn
          >
        </div>
        <v-container fluid></v-container>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="customers"
          :single-select="false"
          item-key="id"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.returnResult="{ item }">
            {{ getReturnResult(item.returnResult) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="pointDialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{ isAdd ? "Add" : "Edit" }} Points
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-3">
          <div class="row pt-3">
            <div class="col-12">
              <v-text-field
                v-model="customer.abn"
                label="ABN"
                name="ABN"
                type="number"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.custno"
                label="Customer Number"
                name="Customer Number"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.basePoints"
                label="Base Points"
                name="Base Points"
                type="number"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.bonusPoints"
                label="Bonus Points"
                name="Bonus Points"
                type="number"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.company"
                label="Company"
                name="Company"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.location"
                label="Location (postcode suburb)"
                name="Location"
                hide-details
                dense
              ></v-text-field>
            </div>
            <div class="col-12">
              <v-text-field
                v-model="customer.comment"
                label="Comment"
                name="comment"
                hide-details
                dense
              ></v-text-field>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" @click="savePoints">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "AddManualPoints",
  data() {
    return {
      selected: [],
      pagination: {
        rowsPerPage: 50,
        descending: false
      },
      query: {
        is_paid: true,
        page_size: 50,
        page_number: 0
      },
      headers: [
        {
          text: "Cust #",
          value: "custno",
          align: "left",
          sortable: true,
          class: ["strong"]
        },
        {
          text: "Base Points",
          value: "basePoints",
          align: "left",
          sortable: true
        },
        {
          text: "Bonus Points",
          value: "bonusPoints",
          align: "left",
          sortable: true
        },
        {
          text: "Company",
          value: "company",
          align: "left",
          sortable: true
        },
        {
          text: "Return Result",
          value: "returnResult",
          align: "left",
          sortable: true
        },
        {
          text: "Sequence",
          value: "sequenceNo",
          align: "left",
          sortable: true
        }
      ],
      records: [],
      loading: false,
      search: "",
      currentRow: undefined,
      customers: [],
      customer: {
        id: 0,
        custNo: null,
        pendingPoints: null,
        pendingBonusPoints: null
      },
      dialog: false,
      pointDialog: false,
      isAdd: false
    };
  },
  mounted() {
    let vm = this;
    vm.getRecords(vm.query);
  },
  methods: {
    ...mapActions("qantas", [
      "GetManualQantasPoints",
      "AddManualQantas",
      "ModifyManualQantas",
      "RemoveManualQantas"
    ]),
    async getRecords(query) {
      let vm = this;
      this.customers = await vm.GetManualQantasPoints(query);
    },
    addPoints() {
      this.isAdd = true;
      this.pointDialog = true;
    },
    async savePoints() {
      if (this.isAdd) {
        try {
          this.customers.push(await this.AddManualQantas(this.customer));
          this.closeDialog();
        } catch (error) {}
      } else {
        try {
          await this.ModifyManualQantas(this.selected[0]);
          var idx = this.customers.indexOf(this.selected[0]);
          this.customers[idx] = this.customer;
          this.closeDialog();
        } catch (error) {}
      }
    },
    deletePoints() {
      let vm = this;
      this.$dialog
        .confirm("You are about to delete points record, are you sure?")
        .then(async function() {
          try {
            await vm.RemoveManualQantas(vm.selected);
            vm.selected.forEach(element => {
              var idx = vm.customers.indexOf(element);
              vm.customers.splice(idx, 1);
            });
          } catch (error) {}
        })
        .catch(() => {});
    },
    editPoints() {
      this.isAdd = false;
      this.customer = this.selected[0];
      this.pointDialog = true;
    },
    closeDialog() {
      this.resetCustomer();
      this.pointDialog = false;
    },
    resetCustomer() {
      this.customer = {
        id: 0,
        custNo: null,
        pendingPoints: null,
        pendingBonusPoints: null
      };
    },
    getReturnResult(value) {
      switch (value) {
        case 0:
          return "Not Sent";
        case 1:
          return "Approved";
        case 2:
          return "Sent";
        case 3:
          return "Rejected";
        case 4:
          return "Accepted";
      }
    }
  }
};
</script>
